import { Yup } from '@festina-life/components'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import { safeValidationPath } from './helpers'

export const usePathSelectorValidations = () => {
  const translate = useTranslate()

  return useMemo(
    () =>
      Yup.array()
        .required(translate('validation.required'))
        .test({
          test: (value) => {
            const safeInputValue = safeValidationPath(value)

            return (
              safeInputValue.length > 0 &&
              safeInputValue.every(Boolean) &&
              safeInputValue.every((part) => part.match(/^[a-zA-Z0-9]+$/)) &&
              !value.join().endsWith('.')
            )
          },
          message: translate(
            'configurationTree.pathSelector.validation.invalidPath',
          ),
        }),
    [translate],
  )
}
